import { useGetRoles } from "@/queries/roles";
import { useEffect, useState } from "react";

const useRoleCatalog = (canLoad = true) => {
  const [page, setPage] = useState(1);
  const { data, isLoading, isFetching } = useGetRoles(
    {
      page,
      per_page: 20,
    },
    canLoad,
  );

  const [roles, setRoles] = useState<
    {
      label: string;
      value: string;
      type: string;
    }[]
  >([]);

  useEffect(() => {
    if (data?.meta.current_page === 1) {
      setRoles(
        data?.data.map((r) => {
          return {
            label: r.name,
            value: r.id,
            type: r.type,
          };
        }) || [],
      );
    } else {
      setRoles((prevRoles) => [
        ...prevRoles,
        ...(data?.data.map((r) => {
          return {
            label: r.name,
            value: r.id,
            type: r.type,
          };
        }) || []),
      ]);
    }
  }, [data]);

  const loadMore = () => {
    if (!data || isLoading || isFetching) return;
    if (data?.meta?.current_page < data?.meta.last_page) {
      setPage((prevPage) => prevPage + 1);
    }
  };

  const hasMore =
    (data?.meta?.current_page || 0) < (data?.meta?.last_page || 0);

  return {
    roles,
    isLoading,
    isFetching,
    loadMore,
    hasMore,
  };
};

export default useRoleCatalog;
